export default __webpack_public_path__ + "static/gs-1-upload--mobile-e83d4fe34931e74204cf96967c520f65.jpg";